import "./About.module.css";
import Header from "@/reusable_sections/Header";
import AboutUs from "./sections/AboutUs";
import CounselorProfileSection from "./sections/CounselorProfileSection";
import Calltoaction from "./sections/Calltoaction";
import AboutAccess from "./sections/AboutAccess";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <AboutUs />
      <CounselorProfileSection />
      <AboutAccess />
      <Calltoaction />
      <Footer />
    </div>;
}